import { render, staticRenderFns } from "./GameScreenshots.vue?vue&type=template&id=fa773df2&scoped=true"
import script from "./GameScreenshots.vue?vue&type=script&lang=js"
export * from "./GameScreenshots.vue?vue&type=script&lang=js"
import style0 from "./GameScreenshots.vue?vue&type=style&index=0&id=fa773df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa773df2",
  null
  
)

export default component.exports